import { createReducer } from '@reduxjs/toolkit';
import {
  pipeLoading,
  pipeLoaded,
  pipesLoadAllFinished,
  pipesLoadAllStarted,
  pipesLoadAllFailed,
  pipeLoadingFailed,
  setPipesLoadingHasFinished,
} from '../thunks/pipes.thunks';
import {
  systemLoadAllStarted,
  systemLoadAllFinished,
  systemLoadAllFailed,
} from '../thunks/systems.thunks';
import {
  datasetsLoadAllStarted,
  datasetsLoadAllFailed,
  datasetsLoadAllFinished,
  datasetsLoadInternalsStarted,
  datasetsLoadInternalsFailed,
} from '../thunks/datasets.thunks';
import { disconnected, subSwitched } from '../thunks/subscriptions.thunks';

type LoadStatusState = {
  pipeLoading: boolean;
  pipeLoadingFailed: boolean;
  pipesLoaded: boolean;
  systemsLoaded: boolean;
  datasetsLoaded: boolean;
  pipesLoading: boolean;
  datasetsLoading: boolean;
  datasetsInternalsLoading: boolean;
  systemsLoading: boolean;
};

const initialState: LoadStatusState = {
  pipeLoading: false,
  pipeLoadingFailed: false,
  pipesLoaded: false,
  systemsLoaded: false,
  datasetsLoaded: false,
  pipesLoading: false,
  datasetsLoading: false,
  datasetsInternalsLoading: false,
  systemsLoading: false,
};

/*
Note: We are using the builder callback for creating a typesafe reducer.
See https://redux-toolkit.js.org/usage/usage-with-typescript#building-type-safe-reducer-argument-objects
*/
export const loadStatusReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(pipeLoading, (state) => {
      state.pipeLoading = true;
    })
    .addCase(pipeLoaded, (state) => {
      state.pipeLoading = false;
    })
    .addCase(pipeLoadingFailed, (state) => {
      state.pipeLoading = false;
    })
    .addCase(pipesLoadAllFinished, (state) => {
      state.pipesLoaded = true;
      state.pipesLoading = false;
    })
    .addCase(setPipesLoadingHasFinished, (state) => {
      state.pipesLoaded = true;
      state.pipesLoading = false;
    })
    .addCase(pipesLoadAllStarted, (state) => {
      state.pipesLoading = true;
    })
    .addCase(pipesLoadAllFailed, (state) => {
      state.pipesLoaded = true;
      state.pipesLoading = false;
    })
    .addCase(systemLoadAllFinished, (state) => {
      state.systemsLoaded = true;
      state.systemsLoading = false;
    })
    .addCase(systemLoadAllStarted, (state) => {
      state.systemsLoading = true;
    })
    .addCase(systemLoadAllFailed, (state) => {
      state.systemsLoaded = true;
      state.systemsLoading = false;
    })
    .addCase(datasetsLoadAllFinished, (state) => {
      state.datasetsLoaded = true;
      state.datasetsLoading = false;
    })
    .addCase(datasetsLoadAllStarted, (state) => {
      state.datasetsLoading = true;
    })
    .addCase(datasetsLoadInternalsStarted, (state) => {
      state.datasetsInternalsLoading = true;
    })
    .addCase(datasetsLoadAllFailed, (state) => {
      state.datasetsLoaded = true;
      state.datasetsLoading = false;
    })
    .addCase(datasetsLoadInternalsFailed, (state) => {
      state.datasetsInternalsLoading = false;
    })
    .addCase(subSwitched, () => {
      return initialState;
    })
    .addCase(disconnected, () => {
      return initialState;
    })
);
